import { Button, Illustration } from '@pandiafi/design-system'
import { Text } from '@pandiafi/components'
import { t } from 'i18next'
import React from 'react'

interface PublicFormResponseProps {
  title: string
  description?: string
  status: 'success' | 'error'
  onClick: () => void
  buttonText: string
}

export const PublicFormResponse: React.FC<PublicFormResponseProps> = ({
  title,
  description,
  status,
  onClick,
  buttonText,
}) => {
  return (
    <div className="flex flex-col gap-5 items-center">
      <Illustration
        name={status === 'success' ? 'house-thumb-up' : 'house-unhappy'}
        className="mb-6 max-h-48 h-48"
        alt={t('common:alt.illustration')}
      />

      <Text className="text-center mb-5" element="h1" size="xl">
        {title}
      </Text>

      {description && (
        <Text element="span" className="text-center mb-5">
          {description}
        </Text>
      )}

      <Button onClick={onClick} type="button" className="mt-5 w-full">
        {buttonText}
      </Button>
    </div>
  )
}
